<template>
  <v-card flat class="pa-1 position-relative">
    <block v-if="loading || saving"></block>

    <v-card class="white component-v-card">
      <v-tabs v-model="internalTab" background-color="transparent" color="primary" class="price-edition-tabs px-4 pt-4">
        <v-tab href="#price-edition-tab-margins">Editar margenes de ganancia</v-tab>
        <v-tab href="#price-edition-tab-prices">Editar precios</v-tab>
      </v-tabs>

      <v-tabs-items v-model="internalTab" class="price-edition-tabs__content">
        <v-tab-item value="price-edition-tab-margins">
          <v-card flat class="pa-4 white">
            <GeneralFilter
              @loading="loading = $event"
              :filterEndpoint="searchAllProducts"
              :columnsFilterEndpoint="loadAllProductsByColumns"
              :columns.sync="allProductsFilterColumns"
              :advancedFilter="true"
              :search="search"
              @emptyFilter="resetVisibleItems"
              @filtered="handleFilteredResponse"
              :hideLimitLabel="true"
              :clearable="true"
            >
              <template #options>
              </template>
              <template #complementFilters>
              </template>
            </GeneralFilter>

            <v-row class="ma-0 my-4 p-2 price-edition-toolbar">
              <v-col cols="12" class="font-weight-bold mb-2">Edicion de margenes de ganancias</v-col>
              <v-col cols="12" md="4" class="price-edition-toolbar__col price-edition-toolbar__col--list">
                <v-autocomplete
                  v-model="selectedPriceListName"
                  :items="priceLists"
                  item-text="label"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Lista de precios"
                  @change="handlePriceListChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="price-edition-toolbar__col price-edition-toolbar__col--reload">
                <v-btn class="btnclean price-edition-toolbar__icon-btn" @click="reloadSelectedPriceList" title="Recargar lista" aria-label="Recargar lista">
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="2" class="price-edition-toolbar__col price-edition-toolbar__col--general">
                <v-text-field
                  v-model="massProfitPercentage"
                  label="% Ganancia general"
                  outlined
                  dense
                  hide-details
                  suffix="%"
                  type="number"
                  min="0"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="price-edition-toolbar__col price-edition-toolbar__col--list-margin">
                <v-text-field
                  v-model="massPriceListProfitPercentage"
                  label="% Margen lista"
                  outlined
                  dense
                  hide-details
                  suffix="%"
                  type="number"
                  min="0"
                  :disabled="!isPriceListSelected"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="price-edition-toolbar__col price-edition-toolbar__col--apply d-flex align-center">
                <v-btn
                  class="btnadd"
                  :disabled="!canApplyMassMargins"
                  @click="applyMassMargins"
                >
                  <v-icon left>mdi-check-all</v-icon>
                  Aplicar
                </v-btn>
              </v-col>
              <v-col cols="12" md="1" class="price-edition-toolbar__col price-edition-toolbar__col--save d-flex align-center">
                <v-btn
                  class="btnsave"
                  :disabled="!hasChanges"
                  :loading="saving"
                  @click="saveChanges"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar margenes
                </v-btn>
              </v-col>
            </v-row>

            <DxDataGrid
              :data-source="filteredItems"
              key-expr="rowKey"
              :show-row-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :column-auto-width="true"
              :no-data-text="noDataText"
              @cell-prepared="handleGridCellPrepared"
            >
              <DxColumnChooser
                :enabled="true"
                mode="select"
                title="Columnas visibles"
                :height="400"
                :width="400"
              />
              <DxStateStoring
                :enabled="true"
                type="localStorage"
                storage-key="conf_price-edition-margins-grid-v2"
              />
              <DxScrolling row-rendering-mode="virtual" />
              <DxPaging :page-size="10" />

              <DxColumn data-field="ID_Item" caption="ID Producto" alignment="left" :visible-index="0"></DxColumn>
              <DxColumn data-field="BarCode" caption="Codigo" alignment="left" :visible-index="1"></DxColumn>
              <DxColumn
                cell-template="name-template"
                caption="Nombre"
                :width="500"
                alignment="left"
                :visible-index="2"
              ></DxColumn>
              <DxColumn data-field="FamilyName" caption="Familia" v-if="true" :visible-index="3"></DxColumn>
              <DxColumn data-field="CategoryName" caption="Categoria" v-if="true" :visible-index="4"></DxColumn>
              <DxColumn data-field="BrandName" caption="Marca" v-if="true" :visible-index="5"></DxColumn>
              <DxColumn
                cell-template="general-margin-template"
                header-cell-template="general-margin-header-template"
                caption="Margen de ganancia general"
                :width="250"
                :visible-index="6"
              ></DxColumn>
              <DxColumn
                cell-template="list-margin-template"
                header-cell-template="list-margin-header-template"
                caption="Margen de ganancia lista de precios"
                :width="250"
                :visible-index="7"
              ></DxColumn>
              <DxColumn cell-template="status-template" caption="Estado" :width="90" :visible-index="8"></DxColumn>

              <template #general-margin-header-template>
                <div class="editable-header">
                  <v-icon small color="#1976d2">mdi-pencil</v-icon>
                  <span>Margen general</span>
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    class="margin-info-btn"
                    title="Informacion sobre margenes"
                    aria-label="Informacion sobre margen general"
                    @click.stop="openMarginInfoDialog('general')"
                  >
                    <v-icon x-small>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
              </template>

              <template #name-template="{ data }">
                <div :title="data.data.ItemNameToBill">
                  {{ data.data.ItemNameToBill }}
                </div>
              </template>

              <template #general-margin-template="{ data }">
                <div
                  class="profit-editor"
                  :class="{
                    'profit-editor--changed': data.data.generalAction === 'updated',
                    'profit-editor--editing': editingRowKey === `${data.data.rowKey}-general`
                  }"
                >
                  <v-icon
                    v-if="editingRowKey !== `${data.data.rowKey}-general`"
                    small
                    class="profit-editor__icon"
                    color="#1976d2"
                  >mdi-pencil</v-icon>
                  <input
                    :value="data.data.GeneralProfitPercentage"
                    type="number"
                    min="0"
                    step="0.0001"
                    @input="handleGeneralMarginInput(data.data, $event.target.value)"
                    @focus="startEditingRow(`${data.data.rowKey}-general`, $event)"
                    @blur="stopEditingRow"
                    class="profit-editor__input"
                    title="Editar margen general"
                    placeholder="0.00"
                  />
                  <span class="profit-editor__suffix">%</span>
                </div>
              </template>

              <template #list-margin-header-template>
                <div class="editable-header">
                  <v-icon small color="#1976d2">mdi-pencil</v-icon>
                  <span>Margen lista</span>
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    class="margin-info-btn"
                    title="Informacion sobre margenes"
                    aria-label="Informacion sobre margen de lista"
                    @click.stop="openMarginInfoDialog('list')"
                  >
                    <v-icon x-small>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
              </template>

              <template #list-margin-template="{ data }">
                <div
                  class="profit-editor"
                  :class="{
                    'profit-editor--changed': data.data.listAction === 'updated',
                    'profit-editor--editing': editingRowKey === `${data.data.rowKey}-list`,
                    'profit-editor--disabled': !isPriceListSelected
                  }"
                >
                  <v-icon
                    v-if="editingRowKey !== `${data.data.rowKey}-list`"
                    small
                    class="profit-editor__icon"
                    :color="isPriceListSelected ? '#1976d2' : '#9ca3af'"
                  >mdi-pencil</v-icon>
                  <input
                    :value="data.data.ProfitMarginPercentage"
                    type="number"
                    min="0"
                    step="0.0001"
                    :disabled="!isPriceListSelected"
                    @input="handleListMarginInput(data.data, $event.target.value)"
                    @focus="startEditingRow(`${data.data.rowKey}-list`, $event)"
                    @blur="stopEditingRow"
                    class="profit-editor__input"
                    title="Editar margen de lista"
                    placeholder="0.00"
                  />
                  <span class="profit-editor__suffix">%</span>
                </div>
              </template>

              <template #status-template="{ data }">
                <div class="text-center">
                  <v-icon
                    v-if="data.data.generalAction === 'updated' || data.data.listAction === 'updated'"
                    color="orange"
                  >mdi-pencil-circle</v-icon>
                  <v-icon v-else color="grey">mdi-minus-circle-outline</v-icon>
                </div>
              </template>
            </DxDataGrid>
          </v-card>
        </v-tab-item>

        <v-tab-item value="price-edition-tab-prices">
          <v-card flat class="pa-4 white">
            <GeneralFilter
              @loading="loading = $event"
              :filterEndpoint="searchPriceListProducts"
              :columnsFilterEndpoint="loadPriceListProductsByColumns"
              :columns.sync="priceListFilterColumns"
              :advancedFilter="true"
              :search="priceSearch"
              @emptyFilter="resetVisiblePriceListItems"
              @filtered="handleFilteredPriceListResponse"
              :hideLimitLabel="true"
              :clearable="true"
            >
              <template #options>
              </template>
              <template #complementFilters>
              </template>
            </GeneralFilter>

            <v-row class="my-4 px-4">
              <v-col cols="12" class="font-weight-bold mb-4">Edicion de listas de precios</v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="selectedPriceListForPrices"
                  :items="availablePriceListsOnly"
                  item-text="label"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Lista de precios"
                  @change="handlePriceListForPricesChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-switch
                  v-model="showOnlyBelowSuggested"
                  inset
                  hide-details
                  class="mt-0 pt-0"
                  label="Solo precios debajo del sugerido"
                  @change="handleBelowSuggestedToggle"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center">
                <div class="text-body-2">
                  {{ visiblePriceListPriceMargins.length }} registros
                  <span v-if="hasPriceChanges"> | {{ modifiedPriceCount }} modificados</span>
                  <span v-if="belowSuggestedCount"> | {{ belowSuggestedCount }} debajo del sugerido</span>
                </div>
              </v-col>
              <v-col cols="12" md="3" class="d-flex justify-end align-center">
                <v-btn
                  class="btnadd mr-2"
                  :disabled="!belowSuggestedCount"
                  :loading="savingPrices"
                  @click="confirmUpdateBelowSuggestedPrices"
                >
                  <v-icon left>mdi-arrow-up-bold-box-outline</v-icon>
                  Actualizar inferiores
                </v-btn>
                <v-btn
                  class="btnsave"
                  :disabled="!canSavePriceChanges"
                  :loading="savingPrices"
                  @click="savePriceListPrices"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar precios
                </v-btn>
              </v-col>
            </v-row>

            <DxDataGrid
              :data-source="visiblePriceListPriceMargins"
              key-expr="rowKey"
              :show-row-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :column-auto-width="true"
              :no-data-text="noDataTextPriceListTab"
            >
              <DxColumnChooser
                :enabled="true"
                mode="select"
                title="Columnas visibles"
                :height="400"
                :width="400"
              />
              <DxStateStoring
                :enabled="true"
                type="localStorage"
                storage-key="conf_price-edition-prices-grid-v2"
              />
              <DxScrolling row-rendering-mode="virtual" />
              <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 25, 50]" />
              <DxPaging :page-size="10" />

              <DxColumn data-field="PriceListName" caption="Lista de precios" :visible-index="0"></DxColumn>
              <DxColumn data-field="ID_Item" caption="ID Producto" :visible-index="1"></DxColumn>
              <DxColumn cell-template="item-name-bill-template" caption="Producto" :width="420" :visible-index="2"></DxColumn>
              <DxColumn data-field="LastPurchasePrice" caption="Ultimo costo compra" :visible-index="3"></DxColumn>
              <DxColumn data-field="AppliedMarginPercentage" caption="Margen aplicado %" :visible-index="4"></DxColumn>
              <DxColumn cell-template="suggested-price-template" caption="Precio sugerido" :visible-index="5"></DxColumn>
              <DxColumn cell-template="item-original-price-template" caption="Precio Actual" :visible-index="6"></DxColumn>
              <DxColumn cell-template="current-price-template" caption="Precio final" v-if="false" :visible-index="7"></DxColumn>
              <DxColumn cell-template="editable-new-price-template" caption="Nuevo precio" :visible-index="8"></DxColumn>
              <DxColumn data-field="GeneralProfitPercentage" caption="Margen general %" :visible-index="9"></DxColumn>
              <DxColumn data-field="ProfitMarginPercentage" caption="Margen lista %" :visible-index="10"></DxColumn>
              <DxColumn cell-template="single-update-template" caption="Accion" :width="160" :visible-index="11"></DxColumn>
              <template #item-name-bill-template="{ data }">
                <div
                  style="text-align: left;">
                  {{ data.data.ItemNameToBill }}
                </div>
              </template>
              <template #suggested-price-template="{ data }">
                <div
                  class="price-indicator"
                  :class="{ 'price-indicator--success': isSuggestedHigherThanCurrent(data.data) }"
                >
                  {{ data.data.SuggestedPrice }}
                </div>
              </template>

              <template #editable-new-price-template="{ data }">
                <div
                  class="price-editor"
                  :class="{
                    'price-editor--changed': data.data.priceAction === 'updated',
                    'price-editor--danger': isEditablePriceBelowSuggested(data.data),
                  }"
                >
                  <input
                    :value="data.data.EditableNewPrice"
                    type="number"
                    min="0"
                    step="0.01"
                    @input="handleEditablePriceInput(data.data, $event.target.value)"
                    class="price-editor__input"
                    title="Editar precio nuevo"
                    placeholder="0.00"
                  />
                </div>
              </template>
              <template #item-original-price-template="{ data }">
                <div
                  class="price-indicator"
                  :class="{ 'price-indicator--danger': isSuggestedHigherThanCurrent(data.data) }"
                >
                  {{ data.data.ItemOriginalPrice }}
                </div>
              </template>
              
              <template #current-price-template="{ data }">
                <div
                  class="price-indicator"
                  :class="{ 'price-indicator--success': isSuggestedHigherThanCurrent(data.data) }"
                >
                  {{ data.data.ItemNewPrice }}
                </div>
              </template>

              <template #single-update-template="{ data }">
                <div class="d-flex justify-center">
                  <v-btn
                    small
                    class="btnadd"
                    :loading="updatingSuggestedRowKey === data.data.rowKey"
                    :disabled="savingPrices || updatingSuggestedRowKey !== null"
                    @click="updateSingleSuggestedPrice(data.data)"
                  >
                    <v-icon left small>mdi-arrow-up-bold-circle-outline</v-icon>
                    Aplicar sugerido
                  </v-btn>
                </div>
              </template>

            </DxDataGrid>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>

    <v-dialog v-model="showMarginInfoDialog" max-width="700">
      <v-card>
        <v-card-title class="d-flex align-center">
          <span>{{ marginInfoTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showMarginInfoDialog = false" aria-label="Cerrar ayuda de margenes">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <div class="margin-info-section" :class="{ 'margin-info-section--active': marginInfoType === 'general' }">
            <div class="margin-info-section__title">Margen general</div>
            <p>
              Actualiza el porcentaje general del producto. Este valor pertenece al producto y aplica cuando no exista un margen configurado para una lista de precios.
            </p>
          </div>

          <div class="margin-info-section" :class="{ 'margin-info-section--active': marginInfoType === 'list' }">
            <div class="margin-info-section__title">Margen lista</div>
            <p>
              Actualiza solo el margen de la lista seleccionada. Si la lista no tiene margen registrado, el campo se muestra vacio.
            </p>
            <p class="mb-0">
              Si guardas <strong>0</strong> y ya existe un margen para esa lista y producto, ese registro se elimina. Si no existe un margen previo, el valor se ignora.
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn class="btnclean" @click="showMarginInfoDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging,
  DxPager,
  DxColumnChooser,
  DxStateStoring,
} from "devextreme-vue/data-grid";
import Alerts from "@/components/Alerts.vue";
import Block from "@/components/Block.vue";
import GeneralFilter from "@/components/GeneralFilter";

const ALL_PRODUCTS_OPTION_ID = "__ALL_PRODUCTS__";

export default {
  name: "PriceEdition",
  components: {
    Alerts,
    Block,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxPager,
    DxColumnChooser,
    DxStateStoring,
    GeneralFilter,
  },
  data() {
    return {
      loading: false,
      saving: false,
      savingPrices: false,
      priceLists: [],
      selectedPriceListName: ALL_PRODUCTS_OPTION_ID,
      selectedPriceListForPrices: null,
      items: [],
      filteredItems: [],
      priceListPriceMargins: [],
      originalItemsMap: {},
      search: {
        filter: null,
      },
      priceSearch: {
        filter: null,
      },
      showOnlyBelowSuggested: false,
      updatingSuggestedRowKey: null,
      pendingAction: null,
      internalTab: "price-edition-tab-margins",
      massProfitPercentage: null,
      massPriceListProfitPercentage: null,
      showMarginInfoDialog: false,
      marginInfoType: "general",
      editingRowKey: null,
      families: [],
      categories: [],
      subcategories: [],
      brands: [],
      allProductsFilterColumns: [
        {
          name: "equals_family",
          title: "Familia",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "equals_category",
          title: "Categoria",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "equals_subcategory",
          title: "Subcategoria",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "equals_items_brand",
          title: "Marca",
          value: "",
          type: "select",
          options: [],
        },
      ],
      priceListFilterColumns: [
        {
          name: "equals_family",
          title: "Familia",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "equals_category",
          title: "Categoria",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "equals_subcategory",
          title: "Subcategoria",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "equals_items_brand",
          title: "Marca",
          value: "",
          type: "select",
          options: [],
        },
      ],
      oldAllProductsFilterColumnsState: [],
      oldPriceListFilterColumnsState: [],
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
    };
  },
  computed: {
    availablePriceListsOnly() {
      return this.priceLists.filter((item) => item.id !== ALL_PRODUCTS_OPTION_ID);
    },
    isPriceListSelected() {
      return !!this.selectedPriceListName && this.selectedPriceListName !== ALL_PRODUCTS_OPTION_ID;
    },
    hasPriceChanges() {
      return this.priceListPriceMargins.some((item) => item.priceAction === "updated");
    },
    canSavePriceChanges() {
      return this.priceListPriceMargins.some(
        (item) => item.priceAction === "updated" && !this.isEditablePriceBelowSuggested(item)
      );
    },
    hasChanges() {
      return this.items.some((item) => item.generalAction === "updated" || item.listAction === "updated");
    },
    modifiedPriceCount() {
      return this.priceListPriceMargins.filter((item) => item.priceAction === "updated").length;
    },
    belowSuggestedCount() {
      return this.priceListPriceMargins.filter((item) => this.isSuggestedHigherThanCurrent(item)).length;
    },
    visiblePriceListPriceMargins() {
      return this.priceListPriceMargins;
    },
    canApplyMassMargins() {
      const hasGeneralValue = this.massProfitPercentage !== null && this.massProfitPercentage !== "";
      const hasListValue = this.isPriceListSelected && this.massPriceListProfitPercentage !== null && this.massPriceListProfitPercentage !== "";
      return hasGeneralValue || hasListValue;
    },
    modifiedCount() {
      return this.items.filter((item) => item.generalAction === "updated" || item.listAction === "updated").length;
    },
    selectedListLabel() {
      const current = this.priceLists.find((item) => item.id === this.selectedPriceListName);
      return current ? current.label : this.selectedPriceListName;
    },
    selectedContextLabel() {
      if (this.isPriceListSelected) {
        return `Editar todos los productos con lista: ${this.selectedListLabel}`;
      }
      return "Editar todos los productos";
    },
    noDataText() {
      return "No hay productos para mostrar con el filtro actual.";
    },
    noDataTextPriceListTab() {
      return this.selectedPriceListForPrices
        ? "No hay productos para mostrar con el filtro actual."
        : "Seleccione una lista de precios para visualizar sus productos y precios.";
    },
    marginInfoTitle() {
      return this.marginInfoType === "list" ? "Informacion de margen de lista" : "Informacion de margen general";
    },
  },
  watch: {
    allProductsFilterColumns: {
      handler(newVal) {
        this.syncDependentFilterOptions(
          newVal,
          this.oldAllProductsFilterColumnsState,
          this.allProductsFilterColumns
        );
        this.oldAllProductsFilterColumnsState = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
    },
    priceListFilterColumns: {
      handler(newVal) {
        this.syncDependentFilterOptions(
          newVal,
          this.oldPriceListFilterColumnsState,
          this.priceListFilterColumns
        );
        this.oldPriceListFilterColumnsState = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
    },
  },
  created() {
    this.oldAllProductsFilterColumnsState = JSON.parse(JSON.stringify(this.allProductsFilterColumns));
    this.oldPriceListFilterColumnsState = JSON.parse(JSON.stringify(this.priceListFilterColumns));
  },
  async mounted() {
    await Promise.all([this.loadPriceLists(), this.initializeAllProductsFilters()]);
    await this.loadAllProducts();
    await this.loadPriceListPriceMargins();
  },
  methods: {
    showAlert(type, header, body) {
      this.alert.type = type || "danger";
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
    },
    // Con aviso de la tienda en línea, la alerta pasa a advertencia y lo agrega al mensaje.
    alertPricesSaved(message, response) {
      const warning = response && response.externalStoreSyncWarning;
      this.showAlert(
        warning ? "warning" : "success",
        warning ? "Precios guardados" : "Exito",
        warning ? message + " " + warning : message
      );
    },
    closeAlert() {
      this.alert.show = false;
      this.pendingAction = null;
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.pendingAction === "updateBelowSuggestedPrices") {
        this.pendingAction = null;
        this.updateBelowSuggestedPrices();
        return;
      }
      this.pendingAction = null;
    },
    openMarginInfoDialog(type) {
      this.marginInfoType = type === "list" ? "list" : "general";
      this.showMarginInfoDialog = true;
    },
    handleGridCellPrepared(e) {
      if (e.rowType !== "data" || !e.cellElement) {
        return;
      }

      const dataField = e.column?.dataField || "";
      const caption = (e.column?.caption || "").trim();

      const skipCaptions = new Set([
        "Margen de ganancia general",
        "Margen de ganancia lista de precios",
        "Nuevo precio",
        "Accion",
        "Estado",
      ]);

      if (skipCaptions.has(caption)) {
        return;
      }

      const leftFields = new Set(["ID_Item", "BarCode", "ItemNameToBill", "FamilyName", "CategoryName", "BrandName", "PriceListName"]);
      const rightFields = new Set(["LastPurchasePrice", "AppliedMarginPercentage", "ItemOriginalPrice", "GeneralProfitPercentage", "ProfitMarginPercentage", "ItemNewPrice"]);
      const leftCaptions = new Set(["Nombre", "Producto"]);
      const rightCaptions = new Set(["Precio sugerido", "Precio final"]);

      const alignment = rightFields.has(dataField) || rightCaptions.has(caption)
        ? "right"
        : leftFields.has(dataField) || leftCaptions.has(caption)
          ? "left"
          : null;

      if (!alignment) {
        return;
      }

      e.cellElement.style.setProperty("text-align", alignment, "important");

      const templateWrapper = e.cellElement.querySelector(".dx-template-wrapper");
      if (templateWrapper) {
        templateWrapper.style.setProperty("text-align", alignment, "important");
        templateWrapper.style.justifyContent = alignment === "right" ? "flex-end" : "flex-start";
      }
    },
    normalizeNumber(value, decimals = 4) {
      if (value === "" || value === null || value === undefined) {
        return null;
      }
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) {
        return null;
      }
      return parseFloat(parsed.toFixed(decimals));
    },
    parseMoneyValue(value) {
      if (value === "" || value === null || value === undefined) {
        return null;
      }
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) {
        return null;
      }
      return parsed;
    },
    syncDependentFilterOptions(newColumns, oldColumnsState, targetColumns) {
      newColumns.forEach((newItem, index) => {
        const oldItem = oldColumnsState[index];
        if (!oldItem || newItem.value === oldItem.value) {
          return;
        }

        if (index === 0) {
          targetColumns[1].value = "";
          targetColumns[2].value = "";
          targetColumns[1].options = this.categories
            .filter((category) => category.id_family == newItem.value)
            .map((category) => ({ name: category.name, value: category.id }));
          targetColumns[2].options = [];
        }

        if (index === 1) {
          targetColumns[2].value = "";
          targetColumns[2].options = this.subcategories
            .filter((subcategory) => subcategory.id_cat == newItem.value)
            .map((subcategory) => ({ name: subcategory.name, value: subcategory.id }));
        }
      });
    },
    applyBaseFilterOptions(columns) {
      columns[0].options = this.families.map((family) => ({
        name: family.name,
        value: family.id,
      }));
      columns[1].options = [];
      columns[2].options = [];
      columns[3].options = this.brands.map((brand) => ({
        name: brand.brand,
        value: brand.id,
      }));
    },
    normalizeAllProductsItem(item, index) {
      const hasPriceListContext = !!item.PriceListName;
      const priceListMargin = hasPriceListContext
        ? this.normalizeNumber(item.ProfitMarginPercentage)
        : null;

      return {
        ...item,
        rowKey: hasPriceListContext
          ? `${item.ID_Item}-${item.PriceListName}-${item.InitialRange ?? "default"}-${item.FinalRange ?? "default"}-${index}`
          : `${item.ID_Item}-${index}`,
        BarCode: item.PrincipalBarCode || item.BarCode || "",
        ItemNameToBill: item.ItemName || item.ItemComercialName || "",
        ItemOriginalPrice: parseFloat(item.ItemOriginalPrice ?? item.ItemPrice ?? 0),
        ItemNewPrice: parseFloat(item.ItemNewPrice ?? item.ItemPrice ?? 0),
        LastPurchasePrice: this.parseMoneyValue(item.LastPurchasePrice),
        GeneralProfitPercentage: this.normalizeNumber(item.GeneralProfitPercentage ?? item.ProfitPercentage),
        ProfitMarginPercentage: priceListMargin,
        ProfitPercentage: this.normalizeNumber(item.ProfitPercentage),
        generalAction: null,
        listAction: null,
      };
    },
    async loadPriceLists() {
      this.loading = true;
      try {
        const lists = await this.$API.priceList.priceListHistory({});
        this.priceLists = [
          { id: ALL_PRODUCTS_OPTION_ID, label: "Editar todos los productos" },
          ...(lists || []).map((item) => ({
            ...item,
            label: item.id,
          })),
        ];
        const firstPriceList = this.priceLists.find((item) => item.id !== ALL_PRODUCTS_OPTION_ID);
        this.selectedPriceListForPrices = firstPriceList ? firstPriceList.id : null;
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Advertencia", "No se pudieron cargar las listas de precios.");
      } finally {
        this.loading = false;
      }
    },
    async initializeAllProductsFilters() {
      try {
        const [families, categories, subcategories, brands] = await Promise.all([
          this.$API.itemtypes.getFamilies(),
          this.$API.itemtypes.getCategories(),
          this.$API.itemtypes.getSubs(),
          this.$API.itemtypes.getBrands(),
        ]);

        this.families = families || [];
        this.categories = categories || [];
        this.subcategories = subcategories || [];
        this.brands = brands || [];
        this.applyBaseFilterOptions(this.allProductsFilterColumns);
        this.applyBaseFilterOptions(this.priceListFilterColumns);
      } catch (error) {
        console.log(error);
      }
    },
    async handlePriceListChange() {
      if (!this.selectedPriceListName) {
        this.selectedPriceListName = ALL_PRODUCTS_OPTION_ID;
      }
      this.search.filter = null;
      this.massProfitPercentage = null;
      this.massPriceListProfitPercentage = null;
      await this.loadAllProducts();
    },
    async reloadSelectedPriceList() {
      await this.loadAllProducts();
    },
    buildAllProductsRequestParams(extra = {}) {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      return {
        business: user.businessid || "",
        branch: user.branch || "",
        ...(this.isPriceListSelected ? { equals_price_list_name: this.selectedPriceListName } : {}),
        ...extra,
      };
    },
    async fetchAllProducts(params = {}) {
      const response = await this.$API.products.getProductsForProfitPercentageEdition(
        this.buildAllProductsRequestParams(params)
      );

      const mapped = (response || []).map((item, index) => this.normalizeAllProductsItem(item, index));
      this.items = mapped;
      this.filteredItems = [...mapped];
      this.originalItemsMap = mapped.reduce((accumulator, item) => {
        accumulator[item.rowKey] = {
          GeneralProfitPercentage: item.GeneralProfitPercentage,
          ProfitMarginPercentage: item.ProfitMarginPercentage,
        };
        return accumulator;
      }, {});

      return mapped;
    },
    async loadAllProducts() {
      this.loading = true;
      try {
        return await this.fetchAllProducts({
          filter: this.search.filter || "",
        });
      } catch (error) {
        console.log(error);
        this.items = [];
        this.filteredItems = [];
        this.originalItemsMap = {};
        this.showAlert("warning", "Advertencia", "No se pudieron cargar los productos.");
        return [];
      } finally {
        this.loading = false;
      }
    },
    normalizePriceListMarginItem(item, index) {
      const generalMargin = this.normalizeNumber(item.GeneralProfitPercentage);
      const priceListMargin = this.normalizeNumber(item.ProfitMarginPercentage);
      const appliedMargin = priceListMargin !== null ? priceListMargin : generalMargin;
      const getPrice = ()=>{
        if(item.SuggestedPrice && item.ItemNewPrice && item.SuggestedPrice > item.ItemNewPrice)
          return parseFloat((item.SuggestedPrice || 0).toFixed(2));

        if(item.ItemNewPrice)
          return item.ItemNewPrice;

        return 0;
      }
      return {
        ...item,
        rowKey: `${item.PriceListName || ""}-${item.ID_Item || ""}-${item.InitialRange ?? "default"}-${item.FinalRange ?? "default"}-${index}`,
        ItemNameToBill: item.ItemName || item.ItemComercialName || "",
        ItemOriginalPrice: this.parseMoneyValue(item.ItemOriginalPrice ?? 0),
        ItemNewPrice: this.parseMoneyValue(item.ItemNewPrice ?? 0),
        LastPurchasePrice: this.parseMoneyValue(item.LastPurchasePrice ?? 0),
        SuggestedPrice: this.parseMoneyValue(item.SuggestedPrice ?? 0),
        GeneralProfitPercentage: generalMargin,
        ProfitMarginPercentage: priceListMargin,
        AppliedMarginPercentage: appliedMargin,
        EditableNewPrice: getPrice(),
        priceAction: null,
      };
    },
    async loadPriceListPriceMargins() {
      if (!this.selectedPriceListForPrices) {
        this.priceListPriceMargins = [];
        return;
      }

      this.loading = true;
      try {
        await this.fetchPriceListProducts({
          filter: this.priceSearch.filter || "",
        });
      } catch (error) {
        console.log(error);
        this.priceListPriceMargins = [];
        this.showAlert(
          "warning",
          "Advertencia",
          typeof error === "string" && error ? error : "No se pudieron cargar los precios de la lista seleccionada."
        );
      } finally {
        this.loading = false;
      }
    },
    async handlePriceListForPricesChange() {
      this.priceSearch.filter = null;
      this.showOnlyBelowSuggested = false;
      await this.loadPriceListPriceMargins();
    },
    async handleBelowSuggestedToggle() {
      await this.loadPriceListPriceMargins();
    },
    confirmUpdateBelowSuggestedPrices() {
      if (!this.selectedPriceListForPrices) {
        this.showAlert("warning", "Advertencia", "Seleccione una lista de precios.");
        return;
      }

      const rowsToUpdate = this.priceListPriceMargins.filter((item) => this.isSuggestedHigherThanCurrent(item));

      if (!rowsToUpdate.length) {
        this.showAlert("warning", "Advertencia", "No hay registros con precio inferior al sugerido.");
        return;
      }

      this.pendingAction = "updateBelowSuggestedPrices";
      this.alert.type = "questionDangerHtml";
      this.alert.header = "Confirmar actualización";
      this.alert.body = `
        ¿Está seguro que desea realizar esta actualización?<br/>
        Esta acción cambiará todos los productos que tengan un precio inferior al precio sugerido por el cálculo de margen de ganancias.<br/>
        <strong>Productos afectados:</strong> ${rowsToUpdate.length}
      `;
      this.alert.show = true;
    },
    handleEditablePriceInput(row, value) {
      const normalized = this.parseMoneyValue(value);
      row.EditableNewPrice = normalized;
      row.priceAction = normalized !== this.parseMoneyValue(row.ItemNewPrice) ? "updated" : null;
    },
    isSuggestedHigherThanCurrent(row) {
      return this.parseMoneyValue(row.SuggestedPrice) > this.parseMoneyValue(row.ItemNewPrice);
    },
    isEditablePriceBelowSuggested(row) {
      const editablePrice = this.parseMoneyValue(row.EditableNewPrice);
      const suggestedPrice = this.parseMoneyValue(row.SuggestedPrice);

      if (editablePrice === null || suggestedPrice === null) {
        return false;
      }

      return editablePrice < suggestedPrice;
    },
    getValidPriceRowsForSave() {
      return this.priceListPriceMargins.filter(
        (item) => item.priceAction === "updated" && !this.isEditablePriceBelowSuggested(item)
      );
    },
    searchAllProducts({ filter }) {
      return this.fetchAllProducts({
        filter: filter || "",
      });
    },
    buildPriceListProductsRequestParams(extra = {}) {
      return {
        PriceListName: this.selectedPriceListForPrices || "",
        only_below_suggested: this.showOnlyBelowSuggested,
        ...extra,
      };
    },
    async fetchPriceListProducts(params = {}) {
      if (!this.selectedPriceListForPrices) {
        this.priceListPriceMargins = [];
        return [];
      }

      const response = await this.$API.products.getPriceListProductsForEdition(
        this.buildPriceListProductsRequestParams(params)
      );

      this.priceListPriceMargins = (response || []).map((item, index) =>
        this.normalizePriceListMarginItem(item, index)
      );

      return this.priceListPriceMargins;
    },
    searchPriceListProducts({ filter }) {
      return this.fetchPriceListProducts({
        filter: filter || "",
      });
    },
    loadAllProductsByColumns(params) {
      return this.fetchAllProducts(params);
    },
    loadPriceListProductsByColumns(params) {
      return this.fetchPriceListProducts(params);
    },
    resetVisibleItems() {
      this.search.filter = null;
      this.editingRowKey = null;
      this.loadAllProducts();
    },
    resetVisiblePriceListItems() {
      this.priceSearch.filter = null;
      this.loadPriceListPriceMargins();
    },
    handleFilteredResponse(response) {
      this.filteredItems = response || [];
      this.editingRowKey = null;
    },
    handleFilteredPriceListResponse(response) {
      this.priceListPriceMargins = response || [];
    },
    applySuggestedPriceToLowerRows(rows) {
      rows.forEach((row) => {
        const suggestedPrice = this.parseMoneyValue(row.SuggestedPrice);
        row.EditableNewPrice = suggestedPrice;
        row.priceAction = suggestedPrice !== this.parseMoneyValue(row.ItemNewPrice) ? "updated" : null;
      });
    },
    markRowAsModified(row) {
      const original = this.originalItemsMap[row.rowKey];
      if (!original) {
        row.generalAction = "updated";
        row.listAction = this.isPriceListSelected ? "updated" : null;
        return;
      }

      const hasGeneralChanges =
        this.normalizeNumber(row.GeneralProfitPercentage) !== this.normalizeNumber(original.GeneralProfitPercentage);
      const hasListChanges =
        this.normalizeNumber(row.ProfitMarginPercentage) !== this.normalizeNumber(original.ProfitMarginPercentage);

      row.generalAction = hasGeneralChanges ? "updated" : null;
      row.listAction = this.isPriceListSelected && hasListChanges ? "updated" : null;
    },
    handleGeneralMarginInput(row, value) {
      const normalized = this.normalizeNumber(value);
      row.GeneralProfitPercentage = normalized;
      row.ProfitPercentage = normalized;
      this.markRowAsModified(row);
    },
    handleListMarginInput(row, value) {
      if (!this.isPriceListSelected) {
        return;
      }
      row.ProfitMarginPercentage = this.normalizeNumber(value);
      this.markRowAsModified(row);
    },
    startEditingRow(rowKey, event) {
      this.editingRowKey = rowKey;
      if (event && event.target && typeof event.target.select === "function") {
        event.target.select();
      }
    },
    stopEditingRow() {
      this.editingRowKey = null;
    },
    applyMassMargins() {
      const generalMargin = this.normalizeNumber(this.massProfitPercentage);
      const listMargin = this.normalizeNumber(this.massPriceListProfitPercentage);
      const hasGeneralValue = generalMargin !== null;
      const hasListValue = this.isPriceListSelected && listMargin !== null;

      if (!hasGeneralValue && !hasListValue) {
        this.showAlert("warning", "Advertencia", "Ingrese al menos un margen válido.");
        return;
      }

      this.filteredItems.forEach((row) => {
        if (hasGeneralValue) {
          row.GeneralProfitPercentage = generalMargin;
          row.ProfitPercentage = generalMargin;
        }
        if (hasListValue) {
          row.ProfitMarginPercentage = listMargin;
        }
        this.markRowAsModified(row);
      });

      this.massProfitPercentage = null;
      this.massPriceListProfitPercentage = null;
      this.showAlert("success", "Exito", "Se aplicaron los margenes a los productos visibles.");
    },
    async saveChanges() {
      const generalProducts = this.items
        .filter((item) => item.generalAction === "updated")
        .map((item) => ({
          ID_Item: item.ID_Item,
          ProfitPercentage: this.normalizeNumber(item.GeneralProfitPercentage) ?? 0,
        }));

      const priceListProducts = this.items
        .filter((item) => this.isPriceListSelected && item.listAction === "updated")
        .map((item) => ({
          ID_Item: item.ID_Item,
          PriceListName: item.PriceListName || this.selectedPriceListName,
          PriceListRowId: item.PriceListRowId || null,
          InitialRange: item.InitialRange ?? null,
          FinalRange: item.FinalRange ?? null,
          ProfitMarginPercentage: this.normalizeNumber(item.ProfitMarginPercentage),
        }));

      if (!generalProducts.length && !priceListProducts.length) {
        this.showAlert("warning", "Advertencia", "No hay cambios para guardar.");
        return;
      }

      this.saving = true;

      try {
        const requests = [];

        if (generalProducts.length) {
          requests.push(this.$API.products.updateProductsProfitPercentageBulk({ products: generalProducts }));
        }

        if (priceListProducts.length) {
          requests.push(
            this.$API.products.updateProductsProfitPercentageBulk({
              priceListName: this.selectedPriceListName,
              products: priceListProducts,
            })
          );
        }

        await Promise.all(requests);
        this.showAlert("success", "Exito", "Los margenes fueron actualizados con exito.");
        await this.loadAllProducts();
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Advertencia", "No se pudieron guardar los margenes.");
      } finally {
        this.saving = false;
      }
    },
    async savePriceListPrices() {
      if (!this.selectedPriceListForPrices) {
        this.showAlert("warning", "Advertencia", "Seleccione una lista de precios.");
        return;
      }

      const validRows = this.getValidPriceRowsForSave();
      const invalidRowsCount = this.priceListPriceMargins.filter(
        (item) => item.priceAction === "updated" && this.isEditablePriceBelowSuggested(item)
      ).length;

      const products = validRows
        .map((item) => ({
          PriceListRowId: item.PriceListRowId || null,
          ID_Item: item.ID_Item,
          InitialRange: item.InitialRange ?? null,
          FinalRange: item.FinalRange ?? null,
          Price: this.parseMoneyValue(item.EditableNewPrice) ?? 0,
        }));

      if (!products.length) {
        this.showAlert(
          "warning",
          "Advertencia",
          invalidRowsCount
            ? "Los precios por debajo del sugerido se marcan en rojo y no se incluyen en la actualizacion."
            : "No hay precios para guardar."
        );
        return;
      }

      this.savingPrices = true;

      try {
        const response = await this.$API.products.updatePriceListProductsPricesBulk({
          priceListName: this.selectedPriceListForPrices,
          products,
        });
        this.alertPricesSaved(
          invalidRowsCount
            ? "Los precios validos fueron actualizados. Los valores por debajo del sugerido se omitieron."
            : "Los precios fueron actualizados con exito.",
          response
        );
        await this.loadPriceListPriceMargins();
      } catch (error) {
        console.log(error);
        this.showAlert(
          "warning",
          "Advertencia",
          typeof error === "string" && error ? error : "No se pudieron guardar los precios."
        );
      } finally {
        this.savingPrices = false;
      }
    },
    async updateBelowSuggestedPrices() {
      if (!this.selectedPriceListForPrices) {
        this.showAlert("warning", "Advertencia", "Seleccione una lista de precios.");
        return;
      }

      const rowsToUpdate = this.priceListPriceMargins.filter((item) => this.isSuggestedHigherThanCurrent(item));

      if (!rowsToUpdate.length) {
        this.showAlert("warning", "Advertencia", "No hay registros con precio inferior al sugerido.");
        return;
      }

      this.applySuggestedPriceToLowerRows(rowsToUpdate);
      const products = rowsToUpdate.map((item) => ({
        PriceListRowId: item.PriceListRowId || null,
        ID_Item: item.ID_Item,
        InitialRange: item.InitialRange ?? null,
        FinalRange: item.FinalRange ?? null,
        Price: this.parseMoneyValue(item.SuggestedPrice) ?? 0,
      }));

      this.savingPrices = true;

      try {
        const response = await this.$API.products.updatePriceListProductsPricesBulk({
          priceListName: this.selectedPriceListForPrices,
          products,
        });
        this.alertPricesSaved("Se actualizaron los registros con precio inferior al sugerido.", response);
        await this.loadPriceListPriceMargins();
      } catch (error) {
        console.log(error);
        this.showAlert(
          "warning",
          "Advertencia",
          typeof error === "string" && error ? error : "No se pudieron actualizar los precios inferiores al sugerido."
        );
      } finally {
        this.savingPrices = false;
      }
    },
    async updateSingleSuggestedPrice(row) {
      if (!this.selectedPriceListForPrices) {
        this.showAlert("warning", "Advertencia", "Seleccione una lista de precios.");
        return;
      }

      const suggestedPrice = this.parseMoneyValue(row?.SuggestedPrice);

      if (suggestedPrice === null) {
        this.showAlert("warning", "Advertencia", "El producto no tiene un precio sugerido valido.");
        return;
      }

      this.updatingSuggestedRowKey = row.rowKey;

      try {
        const response = await this.$API.products.updatePriceListProductsPricesBulk({
          priceListName: this.selectedPriceListForPrices,
          products: [
            {
              PriceListRowId: row.PriceListRowId || null,
              ID_Item: row.ID_Item,
              InitialRange: row.InitialRange ?? null,
              FinalRange: row.FinalRange ?? null,
              Price: suggestedPrice,
            },
          ],
        });
        this.alertPricesSaved(`Se actualizo el precio sugerido para el producto ${row.ID_Item}.`, response);
        await this.loadPriceListPriceMargins();
      } catch (error) {
        console.log(error);
        this.showAlert(
          "warning",
          "Advertencia",
          typeof error === "string" && error ? error : "No se pudo actualizar el precio sugerido del producto."
        );
      } finally {
        this.updatingSuggestedRowKey = null;
      }
    },
  },
};
</script>

<style scoped>
.price-edition-toolbar {
  align-items: center;
}

.price-edition-tabs {
  border-bottom: 1px solid #e5e7eb;
}

.price-edition-tabs__content {
  background: transparent;
}

.price-edition-toolbar__col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.price-edition-toolbar__col .v-btn {
  max-width: 100%;
}

.price-edition-toolbar__icon-btn {
  min-width: 48px !important;
  width: 48px;
  padding: 0 !important;
}

@media (min-width: 960px) {
  .price-edition-toolbar {
    flex-wrap: wrap;
    gap: 12px;
  }

  .price-edition-toolbar__col {
    flex: 1 1 auto;
    max-width: 100%;
  }

  .price-edition-toolbar__col--list {
    flex: 1 1 260px;
    min-width: 260px;
  }

  .price-edition-toolbar__col--reload {
    flex: 0 0 56px;
    min-width: 56px;
  }

  .price-edition-toolbar__col--general,
  .price-edition-toolbar__col--list-margin {
    flex: 1 1 220px;
    min-width: 220px;
  }

  .price-edition-toolbar__col--apply {
    flex: 0 1 132px;
    min-width: 132px;
  }

  .price-edition-toolbar__col--save {
    flex: 0 1 180px;
    min-width: 180px;
  }
}

.editable-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.margin-info-btn {
  margin-left: -2px;
}

.margin-info-section {
  border: 1px solid #dbe7f3;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
  background: #f8fbff;
}

.margin-info-section--active {
  border-color: #90caf9;
  background: #eaf4ff;
}

.margin-info-section__title {
  font-weight: 700;
  color: #1d4f91;
  margin-bottom: 6px;
}

.name-cell {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.profit-editor {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  width: 100%;
  min-width: 150px;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  cursor: text;
  transition: all 0.2s ease;
}

.profit-editor:hover {
  background-color: #e3f2fd;
  border-color: #90caf9;
}

.profit-editor:focus-within {
  border-color: #90caf9;
  box-shadow: none;
  background: #e3f2fd;
}

.profit-editor--changed {
  background: #fff3cd;
  border-color: #ffe082;
}

.profit-editor--disabled {
  background: #f3f4f6;
  border-color: #e5e7eb;
  cursor: not-allowed;
}

.profit-editor--editing {
  gap: 4px;
}

.profit-editor__icon {
  flex: 0 0 auto;
  font-size: 14px !important;
  opacity: 0.7;
}

.profit-editor:hover .profit-editor__icon,
.profit-editor:focus-within .profit-editor__icon {
  opacity: 1;
}

.profit-editor__input {
  width: 68px;
  min-width: 68px;
  border: none;
  outline: none;
  background: transparent;
  color: #1f2937;
  font-weight: 600;
  font-size: 13px;
  text-align: right;
  padding: 0;
  appearance: textfield;
  -moz-appearance: textfield;
  box-shadow: none;
}

.profit-editor__input:disabled {
  color: #9ca3af;
  cursor: not-allowed;
}

.profit-editor__input::placeholder {
  color: #9ca3af;
  font-weight: 500;
}

.profit-editor__input:focus {
  outline: none;
  box-shadow: none;
}

.profit-editor__input::-webkit-outer-spin-button,
.profit-editor__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.profit-editor__suffix {
  flex: 0 0 auto;
  color: #1f2937;
  font-weight: 600;
}

.price-indicator {
  text-align: right;
  font-weight: 600;
  color: #1f2937;
}

.price-indicator--danger {
  color: #c62828;
}
.price-indicator--success{
  color: #00796B;
}

.price-editor {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  transition: all 0.2s ease;
}

.price-editor:focus-within {
  border-color: #90caf9;
  background: #e3f2fd;
}

.price-editor--changed {
  background: #fff3cd;
  border-color: #ffe082;
}

.price-editor--danger {
  border-color: #ef9a9a;
  background: #ffebee;
}

.price-editor__input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #1f2937;
  font-weight: 600;
  font-size: 13px;
  text-align: right;
  padding: 0;
  appearance: textfield;
  -moz-appearance: textfield;
  box-shadow: none;
}

.price-editor__input:focus {
  outline: none;
  box-shadow: none;
}

.price-editor__input::-webkit-outer-spin-button,
.price-editor__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
